import React, { useEffect, useRef } from "react";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/layout/Layout";
import MainPage from "./pages/main/MainPage";
import LoginPage from "./pages/login/LoginPage";
import PrivateRoute from "./routes/PrivateRoute";
import useAuthStore from "./stores/useAuthStore";
import PublicRoute from "./routes/PublicRoute";
import CustomAlert from "./components/alert/CustomAlert";
import CustomDialog from "./components/dialog/CustomDialog";
import Theme from "./styles/theme/Theme";
import EditPage from "./pages/edit/EditPage";
import DetailPage from "./pages/detail/DetailPage";
import Loading from "./components/loading/Loading";
import useLoadingStore from "./stores/useLoadingStore";
import SignUpPage from "./pages/signUp/SignUpPage";

function App() {
  const appRef = useRef<HTMLDivElement>(null);
  const { isLogin } = useAuthStore();
  const { isLoading } = useLoadingStore();

  const redefineHeight = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  useEffect(() => {
    // 모바일 화면의 높이를 맞추기 위해 이벤트 등록 및 초기화 함수 실행
    redefineHeight();
    window.addEventListener("resize", redefineHeight);

    return () => {
      window.removeEventListener("resize", redefineHeight);
    };
  }, []);

  return (
    <CookiesProvider>
      <BrowserRouter>
        <Theme>
          <div className="App" ref={appRef}>
            {isLoading && <Loading />}
            <Layout>
              <Routes>
                <Route element={<PrivateRoute />}>
                  <Route path="/" element={<MainPage />} />
                  <Route path="/edit" element={<EditPage />} />
                  <Route path="/edit/:projectId" element={<EditPage />} />
                  <Route path="/detail/:projectId" element={<DetailPage />} />
                </Route>

                <Route element={<PublicRoute />}>
                  <Route path="/login" element={<LoginPage />} />
                </Route>

                <Route path="/signup" element={<SignUpPage />} />

                <Route
                  path="/*"
                  element={<Navigate to={isLogin ? "/" : "/login"} />}
                />
              </Routes>
            </Layout>

            <CustomAlert />
            <CustomDialog />
          </div>
        </Theme>
      </BrowserRouter>
    </CookiesProvider>
  );
}

export default App;
